import Swiper from "swiper"
import {Navigation, Pagination} from "swiper/modules"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"

export default () => {
	const sliders = document.querySelectorAll('.slider') as NodeListOf<HTMLDivElement>

	if (!sliders) return

	sliders.forEach(slider => {
		let slides =  (slider.dataset.slides) ? slider.dataset.slides : 4
		let space =  (slider.dataset.space) ? slider.dataset.space : 70
		let center =  (slider.dataset.center) ? true : false
		new Swiper(slider, {
			modules: [Navigation, Pagination],
			spaceBetween: space,
			slidesPerView: 1,
			// centeredSlides: true,
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: slides,
				}
			},
			centerInsufficientSlides: center,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			pagination: {
				el: ".swiper-pagination",
				type: "fraction",
			},
		})
	})
}
